import { useParams } from 'react-router-dom'
import { SiteShell } from '@/components/layout/SiteShell'
import { NominationPage } from '@/nominations/NominationPage'
import { readNominationData } from '@/nominations/nominationData'
import { NotFoundPage } from '@/pages/NotFoundPage'

/**
 * Renders the nomination whose data this page was built with. There is no registry lookup here
 * on purpose — see `nominationData.ts`. An unknown slug, or a draft that was never prerendered,
 * has no payload and falls through to the site 404.
 */
export const NominationRoutePage = () => {
  const { nominationSlug } = useParams()
  const nomination = readNominationData(nominationSlug)

  if (!nomination) {
    return (
      <SiteShell>
        <NotFoundPage />
      </SiteShell>
    )
  }

  return <NominationPage nomination={nomination} />
}
